import {
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import _ from "lodash";
import React, { useEffect, useRef } from "react";

const GroupSelector = ({
  pageMeta,
  checkedPages,
  setCheckedPages,
  jumpToPage,
  currentPage,
}) => {
  const itemRefs = useRef({});

  let { allPages = [], lockedPages = [], pageGroups = [] } = pageMeta;

  const sortedPageGroups = [...pageGroups].sort((a, b) => a[0] - b[0]);

  const missingPages = allPages.filter(
    (page) => !_.flatten(pageGroups).includes(page),
  );

  const combined = [
    ...sortedPageGroups.map((group) => ({
      type: "group",
      pages: group,
    })),
    ...missingPages.map((page) => ({
      type: "single",
      pages: [page],
    })),
  ].sort((a, b) => a.pages[0] - b.pages[0]);

  useEffect(() => {
    const page = currentPage + 1;
    /**
     * @type {HTMLDivElement}
     */
    const el = itemRefs.current[page];

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [currentPage]);

  return (
    <List sx={{ flexGrow: 1, overflow: "auto" }}>
      {combined.map((item, index) => {
        if (item.type === "group") {
          const group = item.pages;

          return group.length === 1 ? (
            <ListItemButton
              ref={(el) => {
                if (el) itemRefs.current[group[0]] = el;
              }}
              key={index}
              selected={currentPage === group[0] - 1}
              onClick={() => jumpToPage(group[0] - 1)}
            >
              <ListItemText primary={`Invoice - Page ${group[0]}`} />
            </ListItemButton>
          ) : (
            <React.Fragment key={index}>
              <ListItem>
                <ListItemText primary="Invoice" />
              </ListItem>
              {group.map((page, pageIndex) => (
                <ListItemButton
                  ref={(el) => {
                    if (el) itemRefs.current[page] = el;
                  }}
                  key={pageIndex}
                  sx={{ pl: 4 }}
                  selected={currentPage === page - 1}
                  onClick={() => jumpToPage(page - 1)}
                >
                  <ListItemText primary={`Page ${page}`} />
                </ListItemButton>
              ))}
            </React.Fragment>
          );
        }

        const page = item.pages[0];
        const isChecked = checkedPages.includes(page);
        const isLocked = lockedPages.includes(page);

        let label = isLocked ? `Locked - Page ${page}` : `Page ${page}`;

        return (
          <ListItem
            key={index}
            disablePadding
            secondaryAction={
              !isLocked && (
                <Checkbox
                  checked={isChecked}
                  onChange={() => {
                    setCheckedPages((prev) =>
                      prev.includes(page)
                        ? prev.filter((p) => p !== page)
                        : [...prev, page],
                    );
                    jumpToPage(page - 1);
                  }}
                />
              )
            }
          >
            <ListItemButton
              ref={(el) => {
                if (el) itemRefs.current[page] = el;
              }}
              selected={currentPage === page - 1}
              onClick={() => jumpToPage(page - 1)}
            >
              <ListItemText primary={label} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};

export default GroupSelector;
